'use client'

import { size } from 'lodash-es'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useLocalStorage } from 'react-use'
import { useHouseListContext } from '../layout/context'
import SearchListContent, { SkeletonSearchList } from '../list/content'
import SearchListPagination from '../pagination'
import { getSlugData } from '../utils'

export default function MapList() {

  const { state, listData, listParams, listLoading, listTotals, setHoverData } = useHouseListContext()
  const pageIndex = useMemo(() => getSlugData(state.slug).page, [state])

  const [listLen, setListLen] = useState(parseInt(typeof localStorage === 'object' ? localStorage.getItem('house-list-len') || 0 : 0))
  useEffect(() => {
    localStorage.setItem('house-list-len', size(listData))
    if (size(listData)) {
      setListLen(size(listData))
    }
  }, [listData])

  const [listingClick, setListingClick] = useLocalStorage('map-listing-click')
  useEffect(() => {
    if (!listingClick || !size(listData)) return
    setHoverData(listingClick)
    setListingClick(null)
  }, [listingClick, setListingClick, listData, setHoverData])

  const timeRef = useRef(null)
  return (
    (!listLoading && listData)
      ? (
        <>
          <SearchListContent
            data={listData}
            totals={listTotals}
            pageIndex={pageIndex}
            state={state}
            params={listParams}
            cardProps={{
              onMouseEnter: data => {
                timeRef.current = setTimeout(() => {
                  setHoverData(data)
                }, 500)
              },
              onMouseLeave: () => {
                clearTimeout(timeRef.current)
                setHoverData()
              }
            }}
          />
          <SearchListPagination totals={listTotals} pageIndex={pageIndex} state={state}></SearchListPagination>
        </>
      )
      : <SkeletonSearchList showMap={state.showMap} listLen={listLen}></SkeletonSearchList>
  )
}